export enum UserRole {
    Admin = 'admin',
    Business = 'business',
    Console = 'console'
}
